export const topics = [
  'Herbal Medicine Foundations',
  "Women's Health & Hormonal Wellbeing",
  'Anatomy & Physiology for Holistic Health',
  'Traditional African & Caribbean Healing Systems',
  'Nutrition & Lifestyle Medicine',
  'Emotional Wellbeing & Stress Management',
  'Nature Connection & Herbal Walks',
  'Menopause Education & Support',
]

export const formats = [
  {
    title: 'In-Person Workshops',
    desc: 'Hands-on, immersive learning experiences in a group setting.',
  },
  {
    title: 'Online Courses',
    desc: 'Flexible, self-paced digital programmes accessible from anywhere.',
  },
  {
    title: 'Community Programmes',
    desc: 'Educational workshops designed for community groups and organisations.',
  },
  {
    title: 'Corporate Wellbeing',
    desc: 'Tailored health education for workplace and corporate teams.',
  },
  {
    title: 'Festival & Event Appearances',
    desc: 'Talks and workshops at wellness events and festivals across the UK.',
  },
]

export const galleryImages = [
  { label: 'In-Person Workshop · 01', caption: 'In-Person Workshops' },
  { label: 'Online Learning · 02', caption: 'Online Courses' },
  { label: 'Community Programme · 03', caption: 'Community Programmes' },
]
